module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/onlinecalendars/bravenet_online_calendars_no_need_to_download.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/onlinecalendars/bravenet_online_calendars_no_need_to_download.png
// module id = kplP
// module chunks = 0